import { useState } from "react"

export const NotifState = () => {
    const [openNotif, setOpenNotif] = useState(!("Notification" in window) ? false:true)
    const [allowNotif, setAllowNotif] = useState(false)

    // New State
    const [notification, setNotification] = useState({
        toggled: false,
        list: []
    })
   
    return {
        openNotif: {data: openNotif, set: setOpenNotif},
        allowNotif: {data: allowNotif, set: setAllowNotif},

        // New State
        notification: {data: notification, set: setNotification}
    }
}